import React, { useState, useRef, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

const EditContactDialog = ({ show, handleClose, contact, handleSave }) => {
    const [note, setNote] = useState(contact.note);
    const textAreaRef = useRef(null);

    const onSave = () => {
        handleSave(contact.id, note);
        handleClose();
    };

    useEffect(() => {
        const textArea = textAreaRef.current;
        if (textArea) {
            // Reset height to auto to recalculate scrollHeight
            textArea.style.height = 'auto';
            // Set height to scrollHeight to expand to fit content
            textArea.style.height = textArea.scrollHeight + 'px';
        }
    }, [contact.messages]);

    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>Edit Contact</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group controlId="formNote">
                        <Form.Label><br/>Note</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={1}
                            ref={textAreaRef}
                            value={note}
                            onChange={(e) => setNote(e.target.value)}
                            style={{ overflow: 'hidden', resize: 'none' }}
                        />
                    </Form.Group>
                </Form>
                <Form>
                    <Form.Group controlId="formNote">
                        <Form.Label><br/>Message History</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={1}
                            readOnly
                            ref={textAreaRef}
                            value={contact.messages != null ? contact.messages.join('\n\n') : ""}
                            style={{ overflow: 'hidden', resize: 'none', border: 'none' }}
                        />
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Close
                </Button>
                <Button variant="primary" onClick={onSave}>
                    Save Changes
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default EditContactDialog;
